module.exports = __webpack_public_path__ + "img/20191014165618315.3e524ee3.jpg";